import { loadingView, unloadingView } from '../../../loader.js';
import "./../../../../node_modules/izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";
import { fabric } from "fabric";
import Swiper, { Navigation, Pagination, Lazy, Autoplay } from 'swiper';
import { data } from 'jquery';


export default class Canvas {

    constructor(Parent) {
        this.dataParent = Parent;

        // FOR CONVERSION https://codepen.io/elliz/details/ygvgay
        const deleteIcon = "data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='utf-8'?%3e%3c!-- Generator: Adobe Illustrator 24.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 48 48' style='enable-background:new 0 0 48 48;' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:none;stroke:%23222222;stroke-width:3;stroke-miterlimit:10;%7d .st1%7bfill:none;stroke:%23FFFFFF;stroke-width:3;stroke-miterlimit:10;%7d .st2%7bfill:%23FFFFFF;%7d .st3%7bfill:%23222222;%7d %3c/style%3e%3cg id='Calque_2'%3e%3ccircle class='st0' cx='24.9' cy='22.9' r='18.7'/%3e%3ccircle class='st0' cx='24.9' cy='22.9' r='18.7'/%3e%3ccircle class='st1' cx='24.9' cy='22.9' r='20.8'/%3e%3c/g%3e%3cg id='Calque_3'%3e%3ccircle class='st2' cx='24.9' cy='22.9' r='17.4'/%3e%3c/g%3e%3cg id='Calque_1'%3e%3crect x='22' y='10.7' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -8.9787 24.1641)' class='st3' width='5.3' height='24.4'/%3e%3crect x='12.5' y='20.2' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -8.9664 24.159)' class='st3' width='24.4' height='5.3'/%3e%3c/g%3e%3c/svg%3e";
        const deleteImg = document.createElement('img');
        deleteImg.src = deleteIcon;


        fabric.Object.prototype.controls.deleteControl = new fabric.Control({
            x: 0.5,
            y: -0.5,
            offsetX: 25,
            offsetY: 0,
            cursorStyle: 'pointer',
            mouseUpHandler: this.deleteObjectControl,
            render: this.renderIcon(deleteImg),
            cornerSize: 24
        });

        const cloneIcon = "data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='utf-8'?%3e%3c!-- Generator: Adobe Illustrator 24.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 48 48' style='enable-background:new 0 0 48 48;' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:none;stroke:%23222222;stroke-width:3;stroke-miterlimit:10;%7d .st1%7bfill:none;stroke:%23FFFFFF;stroke-width:3;stroke-miterlimit:10;%7d .st2%7bfill:%23FFFFFF;%7d .st3%7bdisplay:none;%7d .st4%7bdisplay:inline;fill:%23222222;%7d .st5%7bfill:%23222222;%7d %3c/style%3e%3cg id='Calque_2'%3e%3ccircle class='st0' cx='24.9' cy='22.9' r='18.7'/%3e%3ccircle class='st0' cx='24.9' cy='22.9' r='18.7'/%3e%3ccircle class='st1' cx='24.9' cy='22.9' r='20.8'/%3e%3c/g%3e%3cg id='Calque_3'%3e%3ccircle class='st2' cx='24.9' cy='22.9' r='17.4'/%3e%3c/g%3e%3cg id='Calque_1' class='st3'%3e%3crect x='22' y='10.7' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -8.9787 24.1641)' class='st4' width='5.3' height='24.4'/%3e%3crect x='12.5' y='20.2' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -8.9664 24.159)' class='st4' width='24.4' height='5.3'/%3e%3c/g%3e%3cg id='Calque_4'%3e%3cpath class='st5' d='M35,19.5V33H21.5V19.5H35z M18.2,25.2H17V15h10.1v1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-3.4H14.8 v14.6h3.4c0.6,0,1.1-0.5,1.1-1.1C19.3,25.7,18.8,25.2,18.2,25.2z'/%3e%3c/g%3e%3c/svg%3e";
        const cloneImg = document.createElement('img');
        cloneImg.src = cloneIcon;
        fabric.Object.prototype.controls.cloneControl = new fabric.Control({
            x: 0.5,
            y: -0.5,
            offsetX: 25,
            offsetY: 30,
            cursorStyle: 'pointer',
            mouseUpHandler: this.cloneObjectControl,
            render: this.renderIcon(cloneImg),
            cornerSize: 24
        });
    }



    initFilterBackend() {
        fabric.textureSize = 6000;
        if (fabric.enableGLFiltering && fabric.isWebglSupported && fabric.isWebglSupported(fabric.textureSize)) {
            return new fabric.WebglFilterBackend({
                tileSize: fabric.textureSize,
            });
        } else if (fabric.Canvas2dFilterBackend) {
            return new fabric.Canvas2dFilterBackend();
        }
    };


    async introCanvas() {
        console.log('[introCanvas]');

        //this.dataParent.storage.nb_step = $('#load-template').attr('data-nbstep');
        //this.dataParent.storage.current_step = $('#load-template').attr('data-id_step');
        this.dataParent.storage.idProductActive = $('#load-template').attr('data-id_product');
        this.dataParent.storage.pyml = this.dataParent.class.Ajax.getPyml(this.dataParent.storage.idProductActive);

        this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive] = [];
        this.dataParent.storage.thumbs[this.dataParent.storage.idProductActive] = [];
        //$.each(this.dataParent.storage.products, (index, product) => {
        const CanvasElement = $(`<canvas id='canvas' class='other_canvas'></canvas>`);
        document.getElementById('wrapper_custom').appendChild(CanvasElement[0]);


        const dataParent = this.dataParent;
        dataParent.storage.canvas = new fabric.Canvas(`canvas`, {
            selection: false,
            preserveObjectStacking: true,
            stateful: true,
            overlayVpt: true,
            BackgroundVpt: true,
            noScaleCache: true,
            objectCaching: false,
            nbstep: this.dataParent.storage.productData.interface.steps.nbstep,
            step: 1,
            optionsSelling: dataParent.storage.productData.interface.optionsselling,
            numOverlay: 1
        })
            .on('object:added', function (e) { dataParent.class.Canvas.onObjectAdded(e); })
            .on('object:removed', function (e) { dataParent.class.Canvas.onObjectRemoved(e); })
            .on('object:selected', function (e) { dataParent.class.Canvas.onObjectSelected(e); })
            .on('object:moving', function (e) { dataParent.class.Canvas.onObjectMoved(e); })
            .on('object:scaling', function (e) { dataParent.class.Canvas.onObjectScaled(e); })
            .on('object:rotating', function (e) { dataParent.class.Canvas.onObjectRotated(e); })
            .on('object:modified', function (e) { dataParent.class.Canvas.onObjectModified(e); })
            .on('object:mouseover', function (e) { dataParent.class.Canvas.onObjectMouseovered(e); })
            .on('selection:created', function (e) { dataParent.class.Canvas.onSelectionCreated(e); })
            .on('selection:updated', function (e) { dataParent.class.Canvas.onSelectionUpdated(e); })
            .on('after:render', function (e) { dataParent.class.Canvas.onAfterRender(e); })
            .on('mouse:down', function (e) { dataParent.class.Canvas.onCanvasMouseDown(e); })
            .on('mouse:up', function (e) { dataParent.class.Canvas.onCanvasMouseUp(e); })


        dataParent.storage.canvas.controlsAboveOverlay = true;

        let dynamicWidth = false;
        let dynamicHeight = false;
        if (this.dataParent.storage.mobile === false) {
            let wrapperCustomHeight = (($('#wrapper_custom').width() * 1769) / 2745);
            if (wrapperCustomHeight > $('.menu_custom').height()) {
                wrapperCustomHeight = $('.menu_custom').height();
                dynamicHeight = wrapperCustomHeight;
                dynamicWidth = ((2745 * wrapperCustomHeight) / 1749);
            } else {
                dynamicWidth = (($('#wrapper_custom').width() * wrapperCustomHeight) / wrapperCustomHeight);
                dynamicHeight = (1769 * dynamicWidth) / 2745;
            }
            this.dataParent.storage.canvas.setWidth(dynamicWidth);
            this.dataParent.storage.canvas.setHeight(dynamicHeight);
        }
        else {
            // FOR MOBILE
            this.dataParent.storage.canvas.setWidth($('#wrapper_custom').width());
            this.dataParent.storage.canvas.setHeight($('#wrapper_custom').width() / 1.551724137931034);
        }

        $('.picture.tab').addClass('active');
        this.dataParent.class.Dom.getActiveTab();


        // SET MASK OF PRODUCT
        this.dataParent.class.Canvas.setOverlay(1, this.dataParent.storage.canvas);

        // CREATE STEPS UI
        this.dataParent.storage.active_step = '';
        let steps = '<div id="steps" class="swiper">';
        steps += '<div class="swiper-wrapper">';
        for (let i = 1; i <= this.dataParent.storage.productData.interface.steps.nbstep; i++) {
            let active_step = '';
            if (parseInt(this.dataParent.storage.canvas.step) == i) {
                active_step = 'active';
            }
            steps += `<div class="swiper-slide step_${i} ${active_step}"><span>Étape ${i}: ${this.dataParent.storage.productData.interface.steps.stepname[i]}</span><img data-id_step="${i}" class="img_step img_step_${i}" src="/modules/personnalisation/views/img/step-click.jpg" /></div>`;
        }
        steps += '</div>';
        steps += '<div class="button-prev" data-id_step="1"></div>';
        steps += '<div class="button-next" data-id_step="2"></div>';
        steps += '<div class="swiper-pagination"></div>';
        steps += '</div>';

        if (this.dataParent.storage.mobile === true && this.dataParent.storage.productData.productInfo.desc) {
            steps += this.dataParent.storage.productData.productInfo.desc;
        }

        $('#allsteps').append(steps);
        if (this.dataParent.storage.productData.interface.steps.nbstep > 1) {
            $(`#allsteps`).show();
        }

        if (this.dataParent.storage.mobile === true) {
            this.dataParent.storage.swiper.step = new Swiper("#steps", {
                modules: [Navigation, Pagination, Autoplay],
                init: prestashop.ismobile,
                //loop: false,
                pagination: {
                    el: ".swiper-pagination",
                    type: "progressbar",
                },
                navigation: {
                    nextEl: ".button-next",
                    prevEl: ".button-prev",
                },
            });
        }



        const result = await this.dataParent.class.Ajax.loadStickers();



        if (typeof this.dataParent.storage.swiper.picture !== 'undefined') {
            this.dataParent.storage.swiper.picture.update();
        }
        this.dataParent.class.Dom.openSwiper('picture');


        console.log('this.dataParent.storage.pyml', this.dataParent.storage.pyml);

    };


    deleteObjectControl(eventData, transform) {
        console.log('deleteObjectControl', eventData, transform);
        var target = transform.target;
        var canvas = target.canvas;
        canvas.remove(target);
        canvas.renderAll();
    }

    cloneObjectControl(eventData, transform) {
        console.log('cloneObjectControl');
        var target = transform.target;
        var canvas = target.canvas;
        target.clone(function (cloned) {
            cloned.left += 30;
            cloned.top += 30;
            canvas.add(cloned);
            canvas.renderAll();
        }, [
            "name",
            "hasControls",
            "lockMovementX",
            "lockMovementY",
            "lockUniScaling",
            "scaleXOriginal",
            "scaleYOriginal",
            "editable",
            "selectable",
            "width",
            "height",
            "top",
            "left",
            "scaleX",
            "scaleY",
            "minScaleLimit",
            "opacity",
            "originX",
            "originY",
            "centeredScaling",
            "hasRotatingPoint",
            "centeredRotation",
            "lockRotation",
            "lockScalingX",
            "lockScalingY",
            "",
            "id",
            "transparentCorners",
            "cornerStyle",
            "borderColor",
            "cornerSize",
            "cornerColor",
            "cornerShape",
            "cornerBackgroundColor",
            "cornerStrokeColor",
            "objectType",
            "centerOnObject",
        ]);
    }

    renderIcon(icon) {
        return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
            var size = this.cornerSize;
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(icon, -size / 2, -size / 2, size, size);
            ctx.restore();
        }
    }


    async switchCanvas(idProduct) {
        console.log("[switchCanvas]", idProduct, this.dataParent.storage);
        if (this.dataParent.storage.productData.interface.steps.nbstep > 1) {
            $(`#allsteps`).show();
        }
        $("#attributes-panel").find(".loadAttributes").html("");
        $("#AttributesLoadedModal").modal("hide");
        $("#load-template").attr("data-id_product", idProduct);

        var productNow = this.dataParent.class.Dom.productInformation();
        $("#productName").html(productNow.productname);


        /*if (this.dataParent.storage.productData.interface.panels.picture.restrict.addRotation === true) {
            this.dataParent.class.Dom.observeNumeric("picture-angle", this.dataParent.storage.canvas);
        }

        if (this.dataParent.storage.productData.interface.panels.picture.restrict.addZoom === true) {
            this.dataParent.class.Dom.observeNumeric("picture-zoom", this.dataParent.storage.canvas);
        }

        if (this.dataParent.storage.productData.interface.panels.text.restrict.addZoom === true) {
            this.dataParent.class.Dom.observeNumeric("text-zoom", this.dataParent.storage.canvas);
        }
        if (this.dataParent.storage.productData.interface.panels.text.restrict.addRotation === true) {
            this.dataParent.class.Dom.observeNumeric("text-angle", this.dataParent.storage.canvas);
        }
        if (this.dataParent.storage.productData.interface.panels.sticker.restrict.addZoom === true) {
            this.dataParent.class.Dom.observeNumeric("sticker-zoom", this.dataParent.storage.canvas);
        }
        if (this.dataParent.storage.productData.interface.panels.sticker.restrict.addRotation === true) {
            this.dataParent.class.Dom.observeNumeric("sticker-angle", this.dataParent.storage.canvas);
        }
        this.dataParent.class.Dom.observeNumeric("angle", this.dataParent.storage.canvas);
        this.dataParent.class.Dom.observeNumeric("picture-zoom", this.dataParent.storage.canvas);
        this.dataParent.class.Dom.observeNumeric("brightness", this.dataParent.storage.canvas);*/


        //$("#canvas").parent(".canvas-container").show();
        this.dataParent.storage.idProductActive = idProduct;
        await this.dataParent.class.Canvas.loadStepJsonCanvas(1);

        this.dataParent.class.Dom.createImgStepThumb();
        this.dataParent.storage.canvas.renderAll.bind(this.dataParent.storage.canvas);
        this.dataParent.class.Dom.closePanel("othercustom-panel", "cancel");
    };

    sauvegardeCanvas(canvasName) {
        console.log("[sauvegardeImage function] ");
        //canvasName.discardActiveObject();
        //console.log(canvasName);
        const jsonSaveTotal = canvasName.toJSON([
            "id",
            "name",
            "library",
            "libraryName",
            "hasRotatingPoint",
            "hasControls",
            "_controlsVisibility",
            "minScaleLimit",
            "scaleXOriginal",
            "scaleYOriginal",
            "scaleX",
            "scaleY",
            "lockMovementX",
            "lockMovementY",
            "lockRotation",
            "lockScalingX",
            "lockScalingY",
            "lockUniScaling",
            "overlayImage",
            "filters",
            "resizeFilters",
            "optionsSelling",
            "objectType",
            "nbstep",
            "step",
            "numOverlay"
        ]);
        //console.log(jsonSaveTotal);
        return jsonSaveTotal;
    };


    moveToObject(canvasName, ObjectName, value) {
        canvasName.getObjects().forEach(function (o) {
            if (o.name == ObjectName) {
                canvasName.bringForward(o, value);
            }
        });
    };

    putText(docName, objText) {
        console.log("OBJECT for putText ok", objText);

        if (objText.text === undefined) {
            return true;
        }

        docName.setFontSize(objText.fontSize);
        docName.setTextColor(objText.fill);

        if (objText.fontStyle !== undefined) {
            console.log("OBJECT FONT STYLE TO APPLY", objText.fontStyle);
            docName.setFont(objText.fontFamily, objText.fontStyle, objText.fontStyle);
        }


        var ALIGNTEXT = "";
        if (objText.align !== undefined) {
            ALIGNTEXT = objText.align;
        }
        console.log("OBJECT TEXT font family", objText.fontFamily);
        var police = objText.fontFamily;

        if (police != "Arial") {
            console.log("OBJECT FONT POLICE TO APPLY", police);
            console.log(police);
            var regex = / /gi;
            police = police.replace(regex, "");
            police = police.replace(" ", "");
            /*docName.addFont("Roboto-Bold.ttf", "Roboto", "bold");
            docName.setFont("Roboto");
            docName.setFontType("bold");*/

            console.log(police);

            //docName.addFileToVFS(police + ".ttf", police);
            //docName.addFont(police + ".ttf", police, objText.fontStyle);
            // add the font to jsPDF
            //docName.addFileToVFS("NewRocker-normal.ttf", "NewRocker-normal");
            //docName.addFont("NewRocker-normal.ttf", "NewRocker-normal", "normal");

            //docName.addFileToVFS("NewRocker-normal.ttf", font);
            //docName.addFont("PermanentMarker-Regular.ttf", "NewRocker", "normal");

            //jsPDF.API.events.push(['addFonts', callAddFont])
            //docName.setFont("NewRocker");

            //docName.setFontType(objText.fontStyle);
            /*docName.addFont("Roboto-Bold.ttf", "Roboto", "bold");
      docName.setFont("Roboto");
      docName.setFontType("bold");*/


            // add the font to jsPDF
            //doc.addFileToVFS("./fonts/Modak-Regular.ttf", myFont);
            //doc.addFont("Modak-Regular.ttf", "Modak-Regular", "normal");
            console.log(docName.getFontList());
            docName.setFont(police + "-Regular");
            //docName.setFont('Righteous');

            // docName.text(
            //     objText.text,
            //     objText.left,
            //     objText.top,
            //     objText.flag,
            //     objText.angle,
            //     ALIGNTEXT
            // );
        }

        docName.text(
            objText.text,
            objText.left,
            objText.top,
            objText.flag,
            objText.angle,
            ALIGNTEXT
        );
    };




    async setStepJsonCanvas(canvas, toStep, updateImgStep) {
        console.log('[setStepJsonCanvas]', canvas, toStep, updateImgStep);

        if (this.dataParent.storage.productData.interface.steps.nbstep > 0) {

            if (canvas === undefined) {
                canvas = this.dataParent.storage.canvas;
            }

            if (toStep === undefined) {
                toStep = canvas.step;
            }
            if (updateImgStep === undefined) {
                updateImgStep = true;
            }
            console.log('[setStepJsonCanvas] if undefined', canvas, toStep, updateImgStep);
            //const stepsDone = Object.keys(this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive]);


            $('#steps').find('[data-id_step]').css({ 'border-color': '#000000', color: '#000000' });
            if (this.dataParent.storage.productData.interface.belt) {
                this.dataParent.class.Canvas.moveToTopObject(canvas, 'fabricObj_sticker', "smiley");
                this.dataParent.class.Canvas.moveToTopObject(canvas, 'fabricObj_belt', "ceinture");
                this.dataParent.class.Canvas.moveToTopObject(canvas, 'fabricObj_text', "text");
                this.dataParent.class.Canvas.moveToTopObject(canvas, 'fabricObj_text', "txtsmiley");

                console.log('************************************************toStep', toStep);
                if (toStep > 1) {
                    this.dataParent.class.Canvas.removeObjectType(canvas, 'txtsmiley');
                    this.dataParent.class.Canvas.removeObjectType(canvas, 'text');
                }
            }

            const canvasWithAllProperties = this.dataParent.class.Canvas.sauvegardeCanvas(canvas);
            this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive][canvas.step] = canvasWithAllProperties;
            if (updateImgStep === true) {
                console.log('* UPDATE updateImgStep *', this.dataParent.storage.idProductActive, toStep, this.dataParent.storage);
                const res = await this.dataParent.class.Canvas.setStepThumb(this.dataParent.storage.idProductActive, toStep);
                this.dataParent.class.Dom.createImgStepThumb(toStep, canvas);
            }

        }
    };



    async createForeinProducts(idProduct) {
        console.log('[createForeinProducts]', this.dataParent.storage);
        if (idProduct === undefined) {
            idProduct = this.dataParent.storage.idProductActive;
        }
        let html = '';
        const dataParent = this.dataParent;
        //const res = await dataParent.class.Dom.clickLoadStep(1);



        //dataParent.storage.canvas.clone(function (canvasTmp) {
        (async () => {
            // LIST ALL FOREIGN PRODUCTS
            let x = 0;
            for (let idProductLoop in dataParent.storage.products) {

                if (idProductLoop !== idProduct) {
                    x++;
                    dataParent.storage.stepJsonCanvas[idProductLoop] = [];
                    dataParent.storage.thumbs[idProductLoop] = [];

                    html += `<div class="presentProduct" data-id_product="${idProductLoop}">
                    <div class="presentText">${x}: ${dataParent.storage.products[idProductLoop]['productname']}</div>`;

                    html += `<div class="img-group">`;
                    // LIST ALL STEPS OF THIS PRODUCT
                    for (let i = 1; i <= dataParent.storage.productData.interface.steps.nbstep; i++) {
                        const canvastmp = await dataParent.class.Canvas.setCanvasTmp(dataParent.storage.stepJsonCanvas[idProduct][i]);
                        const mask = await dataParent.class.Canvas.setMask(canvastmp.numOverlay, canvastmp, idProductLoop);
                        canvastmp.renderAll.bind(canvastmp);

                        const canvasWithAllProperties = dataParent.class.Canvas.sauvegardeCanvas(canvastmp);
                        dataParent.storage.stepJsonCanvas[idProductLoop][i] = canvasWithAllProperties;
                        dataParent.storage.thumbs[idProductLoop][i] = canvastmp.toDataURL({
                            format: 'png',
                            quality: 0.8,
                        });
                        html += `<img alt="Créez votre ${dataParent.storage.products[idProductLoop]['productname']}" title="Créez votre ${dataParent.storage.products[idProductLoop]['productname']}" id="${idProductLoop}" class="img-responsive ${dataParent.storage.products[idProductLoop]['class']}" src="${dataParent.storage.thumbs[idProductLoop][i]}" data-productname="${dataParent.storage.products[idProductLoop]['productname']}" />`;
                        console.log('dataParent.storage.stepJsonCanvas loop loop', idProduct, idProductLoop, i, dataParent.storage.stepJsonCanvas);
                    }
                    html += `</div>`;
                    html += `</div>`;
                }
            };

            $('#img_custom').html(html);
            $('#attributes-panel').hide();
            dataParent.class.Dom.openPanel('othercustom-panel');
            return true;
        })();
        /*},
            [
                "id",
                "name",
                "library",
                "libraryName",
                "hasRotatingPoint",
                "hasControls",
                "_controlsVisibility",
                "minScaleLimit",
                "scaleX",
                "scaleY",
                "lockMovementX",
                "lockMovementY",
                "lockRotation",
                "lockScalingX",
                "lockScalingY",
                "lockUniScaling",
                "overlayImage",
                "filters",
                "resizeFilters",
                "optionsSelling",
                "nbstep",
                "step"
            ]);*/
    }





    async setMask(numOverlay, canvasName, idProduct) {
        console.log('[setMask]', numOverlay, idProduct, canvasName.step, canvasName);
        const dataParent = this.dataParent;
        const promise = await loadingView(
            "customMask",
            "create.svg",
            "Préparation du fond...",
            null);

        return new Promise((resolve, reject) => {

            if (idProduct === undefined) {
                idProduct = this.dataParent.storage.idProductActive;
                console.log('new idProduct => ' + idProduct);
            }
            //const url = "/modules/personnalisation/views/img/overlays/mask_idproduct_" + idProduct + "_step_" + canvasName.step + ".png?rand=" + Math.random();
            let url = "/modules/personnalisation/views/img/overlays/mask_idproduct_" + idProduct + "_step_" + canvasName.step + ".png";
            if (canvasName.optionsSelling.outline && canvasName.optionsSelling.outline.online === true) {
                url = "/modules/personnalisation/views/img/overlays/mask_idproduct_" + idProduct + "_color_" + numOverlay + "_step_" + canvasName.step + ".png";
            }

            console.log('[setmask] numOverlay url', numOverlay, url);




            console.log('url img', url);
            fabric.Image.fromURL(url, function (img) {
                console.log('img', img);
                img.set({
                    scaleX: canvasName.width / img.width,
                    scaleY: canvasName.height / img.height,
                    excludeFromExport: true,
                    opacity: 1,
                });
                canvasName.setOverlayImage(
                    img,
                    function () {
                        canvasName.renderAll.bind(canvasName);
                        if (numOverlay > 1) {
                            canvasName.numOverlay = numOverlay;
                            canvasName.optionsSelling.outline.use = true;
                            canvasName.optionsSelling.outline.data = dataParent.storage.objs[idProduct].mask.colors.file[numOverlay];
                            canvasName.optionsSelling.outline.sell = dataParent.storage.productData.interface.optionsselling.outline.sell;
                        } else {
                            //canvasName.optionsSelling.outline.use = false;
                        }

                        canvasName.controlsAboveOverlay = false;
                        const scaleY = canvasName.height / img.height;
                        if (dataParent.storage.canvas.step == 1 && dataParent.storage.productData.interface.belt) {

                            // CTRL IF BELT DOSE NOT EXIST
                            var fabricObj_belt = dataParent.class.Canvas.getObject(canvasName, "fabricObj_belt", "ceinture");
                            console.log('fabricObj_belt exist?', fabricObj_belt);
                            if (fabricObj_belt === false) {
                                var ObjectOptions = {
                                    borderColor: "#222222",
                                    centeredScaling: true,
                                    //cornerStyle: "circle",
                                    cornerSize: 15,
                                    //cornerColor: "#222222",
                                    cornerShape: "circle",
                                    cornerBackgroundColor: "#222222",
                                    cornerStrokeColor: "#000",
                                    editable: false,
                                    fill: "#231F20",

                                    hasControls: dataParent.storage.productData.interface.belt.restrict.hasControls,
                                    height: dataParent.storage.pyml.canvaspx.coords.belt.height * scaleY,
                                    id: "20",
                                    layer: 20,
                                    left: dataParent.storage.canvas.width / 2,
                                    lockMovementX: dataParent.storage.productData.interface.belt.restrict.lockMovementX,
                                    lockMovementY: dataParent.storage.productData.interface.belt.restrict.lockMovementY,
                                    lockRotation: dataParent.storage.productData.interface.belt.restrict.lockRotation,
                                    lockScalingX: dataParent.storage.productData.interface.belt.restrict.lockScalingX,
                                    lockScalingY: dataParent.storage.productData.interface.belt.restrict.lockScalingY,
                                    lockUniScaling: dataParent.storage.productData.interface.belt.restrict.lockUniScaling,
                                    name: dataParent.storage.productData.interface.belt.restrict.objectName,
                                    objectType: dataParent.storage.productData.interface.belt.restrict.objectType,
                                    originX: "center",
                                    originY: "center",
                                    selectable: dataParent.storage.productData.interface.belt.restrict.selectable,
                                    textAlign: "center",
                                    top: dataParent.storage.pyml.canvaspx.coords.belt.top * scaleY,
                                    //transparentCorners: false,
                                    //width: canvasName.width * dataParent.storage.productData.interface.belt.restrict.percentWidth[canvasName.id_canvas] + 5, // +5 ajustement ceinture trop petite why?!
                                    width: dataParent.storage.pyml.canvaspx.coords.belt.width,
                                };
                                var ceinture_polygone = new fabric.Rect(ObjectOptions);
                                console.log('add belt top', dataParent.storage.pyml.canvaspx.coords.belt.top * scaleY);
                                canvasName.add(ceinture_polygone);

                                // ADD TEXT BELT BY DEFAULT IF STEP 1
                                dataParent.class.Canvas.setTextInputOnCanvas('Ajoutez votre texte', canvasName);

                                // ADD LOBSTER FONT BY DEFAULT
                                const object = dataParent.class.Canvas.getObject(dataParent.storage.canvas, 'fabricObj_text', 'text');
                                dataParent.class.Dom.loadAndUse('Lobster', object, dataParent.storage.canvas);
                            }


                            // dataParent.class.Canvas.moveToObject(canvasName, "fabricObj_belt", 20);
                            // dataParent.class.Canvas.moveToTopObject(canvasName, "text");

                            dataParent.class.Canvas.moveToTopObject(canvasName, 'fabricObj_belt', "ceinture");
                            dataParent.class.Canvas.moveToTopObject(canvasName, 'fabricObj_text', "text");
                            //console.log('canvasName 2', canvasName);
                        }


                        // SET BACKGROUND COLOR DEFAULT AFTER OVERLAY
                        let cloneOptions = [];
                        //console.log("canvasName.backgroundColor:" + canvasName.backgroundColor);
                        if (dataParent.storage.productData.interface.backgroundcolor && !canvasName.backgroundColor) {
                            canvasName.setBackgroundColor(
                                dataParent.storage.productData.interface.backgroundcolor,
                                canvasName.renderAll.bind(canvasName)
                            );
                            //                console.log("set backgroundColor : " + dataParent.storage.productData.interface.backgroundcolor);
                            cloneOptions.backgroundColor = dataParent.storage.productData.interface.backgroundcolor;
                        }
                        //if (canvasName.overlayImage) {
                        // PB SI ACTIVE OVERLAY IS SAME ON ALL CLONED CANVAS
                        //cloneOptions.overlayImage = canvasName.overlayImage;
                        //}

                        //console.log('copytostep on setMask', numOverlay, canvasName);
                        dataParent.class.Canvas.setStepJsonCanvas(canvasName, undefined, false);
                        canvasName.renderAll();
                        console.log('[setMask] resolve', dataParent.storage);
                        resolve('ok');
                        unloadingView('customMask');
                    },
                    {
                        //scaleX: canvasName.width / img._originalElement.naturalWidth,
                        //scaleY: canvasName.height / img._originalElement.naturalHeight,
                        opacity: 1,
                        numOverlay: numOverlay,
                        objectType: "mask",
                        name: "fabricObj_mask",
                    }
                );


            });
        });
    }

    async setOverlay(numOverlay, canvasName) {
        console.log('[setOverlay] canvasName', numOverlay, canvasName, this.dataParent.storage.stepJsonCanvas)
        const mask = await this.dataParent.class.Canvas.setMask(numOverlay, canvasName);

        for (var step = 1; step <= this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive][1].nbstep; step++) {
            // load canvastmp
            console.log('[setOverlay] canvastmp loop', numOverlay, canvastmp, this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive][step])
            const canvastmp = await this.dataParent.class.Canvas.setCanvasTmp(this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive][step]);
            const mask = await this.dataParent.class.Canvas.setMask(numOverlay, canvastmp);
            // update all canvas
            this.dataParent.class.Canvas.setStepJsonCanvas(canvastmp, step, true);
        }

        //this.dataParent.class.Dom.commandBtnUpdate(canvasName);
    };


    applyFilter(index, filter) {
        const obj = this.dataParent.class.Canvas.getObjectSystem(this.dataParent.storage.canvas, this.dataParent.storage.tabActive);
        console.log('[applyFilter]', obj);
        if (obj !== false) {
            obj.filters = [];
            obj.filters.push(filter);
            obj.applyFilters();
            console.log('### applyFilter ---');
            this.dataParent.class.Canvas.setStepJsonCanvas();
        }
        else {
            console.log("setObject : obj inexistant");
            var options = [];
            //options.message = "Pour modifier un objet de type «" + this.dataParent.class.Dom.getActiveTab("lang") + "», vous devez en séléctionner un.";
            options.message = "Merci de séléctionner l'objet concerné.";

            this.dataParent.class.Dom.messageAlert(options);

        }

    };

    applyFilterValue(index, prop, value) {
        console.log('[applyFilterValue]', index, prop, value);

        let obj = this.dataParent.class.Canvas.getObjectSystem(this.dataParent.storage.canvas, this.dataParent.storage.tabActive);
        console.log('[applyFilterValue] obj', obj);
        // if (obj !== false) {
        if (obj !== undefined) {
            console.log('[applyFilterValue] obj.filters', obj.filters);
            //var obj = canvasActive.getActiveObject();
            if (prop === "brightness" && !obj.filters[index]) {
                this.dataParent.class.Canvas.applyFilter(
                    5,
                    new this.dataParent.storage.fabric.filter.Brightness({
                        brightness: value / 1000,
                    })
                );
                console.log("new Populate.storage.fabric.filter.Brightness");
                //console.log(obj.filters[index]);
                this.dataParent.storage.canvas.renderAll();
            }
            //console.log(obj);
            if (obj.filters[index]) {
                console.log("filtre existant -> modification valeur");
                obj.filters[index][prop] = value / 100;
                //console.log('obj.filters[index][prop]' + obj.filters[index][prop]);
                obj.applyFilters();
                this.dataParent.storage.canvas.renderAll();
            }
        }
        else {
            console.log("setObject : obj inexistant");
            var options = [];
            //options.message = "Pour modifier un objet de type «" + this.dataParent.class.Dom.getActiveTab("lang") + "», vous devez en séléctionner un.";
            options.message = "Merci de séléctionner l'objet concerné.";

            this.dataParent.class.Dom.messageAlert(options);
        }
    };

    setGradient(object) {
        console.log('object.height', object.height, object);
        const gradient = new fabric.Gradient({
            type: 'linear',
            gradientUnits: 'percentage', // or 'percentage'
            coords: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1,
            },
            colorStops: [
                { offset: 0, color: '#9400D3' },
                { offset: 0.15, color: '#4B0082' },
                { offset: 0.30, color: '#0000FF' },
                { offset: 0.45, color: '#00FF00' },
                { offset: 0.6, color: '#FFFF00' },
                { offset: 0.75, color: '#FF7F00' },
                { offset: 1, color: '#FF0000' }
            ]
        });
        object.set('fill', gradient);
        //this.dataParent.class.Canvas.setAngle(object, 45);
    }

    setAngle(object, angle) {
        object.set('angle', angle);
    }


    deletePicture(step) {
        console.log("### deletePicture function");
        $("#imageLoader_" + step).val("");

        // REACTIVE POSSIBLE NOTICE ZOOM
        this.dataParent.storage.notice.allstep = false;

        if (this.dataParent.storage.productData.interface.panels.picture.restrict.unique === true) {
            this.dataParent.class.Canvas.removeObject(this.dataParent.storage.canvas, this.dataParent.storage.productData.interface.panels.picture.restrict.objectName);
            $("#photo-upload-txt").html("Importer");
            this.dataParent.class.Dom.activeItemsAction("picture", false);
        } else {
            this.dataParent.class.Canvas.removeObject(this.dataParent.storage.canvas);
        }
        //canvasName.optionsSelling.image.use = false;

        //this.dataParent.class.Dom.commandBtnUpdate(this.dataParent.storage.canvas);
    };

    addSticker(canvasName, options) {

        console.log("[addSticker]", this.dataParent.storage.tabActive, options);
        const dataParent = this.dataParent;
        console.log('dataParent.storage.productData.interface.panels[dataParent.storage.tabActive]', dataParent.storage.productData.interface.panels[dataParent.storage.tabActive]);
        $(`#swiper-container-sticker .item-action`).removeClass('offline');
        const top = dataParent.storage.productData.interface.panels.sticker.restrict.top ? ((70 * canvasName.height) / 100) : canvasName.height / 2;
        let animateStartEnd = top;
        var svgOptions = {
            left: dataParent.storage.productData.interface.panels.sticker.restrict.left ? canvasName.width / 3 : canvasName.width / 2,
            top: top - 100,
            scaleX: 1,
            scaleY: 1,
            scaleXOriginal: 1,
            scaleYOriginal: 1,
            hoverCursor: "pointer",
            opacity: 1,
            minScaleLimit: 0.001,
            originX: "center",
            originY: "center",
            crossOrigin: "anonymous",
            centeredScaling: true,
            stroke: "blue",
            strokeWidth: 2,
            strokeUniform: true,
            borderColor: "#222222",
            borderDashArray: [2, 4],
            cornerShape: "circle",
            cornerBackgroundColor: "#222222",
            objectType: options.objectType,
            name: dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.objectName,
            id: "100",
        };


        if (options.areaRestrict === true) {
            if (dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.centerOnObject) {
                svgOptions.centerOnObjectName = dataParent.class.Canvas.getObject(canvasName, dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.centerOnObject, 'ceinture');
                svgOptions.left = svgOptions.centerOnObjectName.getCenterPoint().x;
                //svgOptions.top = svgOptions.centerOnObjectName.getCenterPoint().y - 200;
                svgOptions.top = svgOptions.centerOnObjectName.getCenterPoint().y;
                //animateStartEnd = svgOptions.centerOnObjectName.getCenterPoint().y;
                console.log('centerOnObject ok');
            }
            //const scaleY = canvasName.height / img.height
            //svgOptions.width = dataParent.storage.objs[dataParent.storage.idProductActive].canvaspx.coords.belt.height * scaleY;
            //svgOptions.height = dataParent.storage.objs[dataParent.storage.idProductActive].canvaspx.coords.belt.height * scaleY;
            if (dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.scaleX) {
                svgOptions.scaleX = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.scaleX[1];
                if (this.dataParent.storage.mobile === true) {
                    //svgOptions.scaleX = svgOptions.scaleX - 0.45;
                    svgOptions.scaleX = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.scaleX[0];
                }
            }
            if (dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.scaleY) {
                svgOptions.scaleY = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.scaleY[1];
                if (this.dataParent.storage.mobile === true) {
                    svgOptions.scaleY = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.scaleY[0];
                }
            }

            svgOptions.centerOnObject = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.centerOnObject;
            svgOptions.lockMovementY = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.lockMovementY;
            svgOptions.lockRotation = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.lockRotation;
            svgOptions.lockScalingX = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.lockScalingX;
            svgOptions.lockScalingY = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.lockScalingY;
            svgOptions.hasRotatingPoint = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.hasRotatingPoint;
            svgOptions.hasControls = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.hasControls;
            svgOptions.centeredRotation = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.addRotation;
            svgOptions.lockUniScaling = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.lockUniScaling;

            if (dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.left) {
                svgOptions.left = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.left[1];
                if (dataParent.storage.mobile === true) {
                    svgOptions.left = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.left[0];
                }
            }
            if (dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.top) {
                svgOptions.top = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.top[1];
                if (dataParent.storage.mobile === true) {
                    svgOptions.top = dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.top[0];
                }
            }
        }

        fabric.loadSVGFromURL(options.imgSrc, function (objects, options) {

            var svg = fabric.util.groupSVGElements(objects, options);
            console.log('addSticker svgOptions', svgOptions, dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict);
            svg.set(svgOptions);

            canvasName.add(svg);

            if (dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.setControlsVisibility === true) {
                svg.setControlsVisibility(dataParent.storage.HideControls);
            } else {
                svg.setControlsVisibility(dataParent.storage.HideControlsAll);
            }

            canvasName.setActiveObject(svg);
            canvasName.renderAll();
        });
    };



    SelectObject(canvasName, ObjectName) {
        console.log("[SelectObject function] : ObjectName " + ObjectName);
        const dataParent = this.dataParent;
        canvasName.getObjects().forEach(function (o) {
            console.log("liste :" + o.name + " -> objet recherché :" + ObjectName);
            if (o.name == ObjectName) {
                canvasName.setActiveObject(o);
                console.log("Objet : " + o.name + " selectionné Ok");
            }
            if (o.name == "fabricObj_text") {
                dataParent.class.Dom.activeTextEditor();
            }
        });
    };


    deleteAllFilters(object, canvasName) {
        // OBJ SELETED ?
        //var objSelected = canvasName.getActiveObject();
        console.log("### deleteAllFilters function canvas ID " + canvasName.id_canvas);
        console.log(object);
        console.log(typeof object);

        if (object !== undefined && object !== null) {
            var activeFilters = object.filters;
            activeFilters.forEach(function (index, val) {
                console.log(index); //klass {matrix: Array(20)}
                console.log(val); // 15
                //$('#' + filters[index]).attr('data-value', filterDataNew);
                delete object.filters[val];
                $("#filtersSwiper").find(".item-action").attr("data-value", "disabled");
                console.log("delete filter " + index);
            });
            object.applyFilters();
            canvasName.renderAll();
            console.log(object.filters.length);
            console.log("delete all filter and editonclone");
            //this.dataParent.class.Canvas.editOnClones(object);
        } else {
            console.log("ok");
            var options = [];
            options.message = "Vous devez sélectionner votre image pour supprimer les filtres associés.";
            this.dataParent.class.Dom.messageAlert(options);
        }
        this.dataParent.class.Canvas.setStepJsonCanvas();
    };


    modifyLayerObject(object, direction) {
        console.log(object);
        //if (productData.interface.panels.text.restrict.unique === true || object.get('name') === "fabricObj_text")
        if (this.dataParent.storage.productData.interface.panels.text.restrict.unique === true && object.get("name") === "fabricObj_text") {
            this.dataParent.class.Dom.messageAlert({
                message: "Vous ne pouvez pas ajuster la profondeur de cet élément sur ce type de produit personnalisable.",
            });
            console.log("modifyLayerObject function ");
        } else {
            if (direction === "front") {
                object.bringForward();
            } else if (direction === "back") {
                object.sendBackwards();
            }
        }
    };


    deleteObject(canvasName) {
        console.log("function deleteObject on canvas");
        // OBJ SELETED ?
        var objSelected = canvasName.getActiveObject();
        console.log(objSelected);
        console.log(typeof objSelected);
        if (objSelected !== undefined && objSelected !== null && objSelected.objectType !== undefined) {
            canvasName.remove(objSelected);
            console.log("delete objSelected");
        } else {
            this.dataParent.class.Dom.messageAlert({
                message: "Pour supprimer un objet de type «" + this.dataParent.class.Dom.getActiveTab("lang") + "», vous devez en séléctionner un.",
            });
        }
    };

    getObjectSystem(canvasName, objectType) {
        console.log("[getObjectSystem] | objectType: " + objectType, canvasName);
        //console.log(productData.interface.panels[objectType]);

        //console.log(this.dataParent.storage.productData.interface.panels[objectType].restrict.unique);



        // IF TAB ACTIVE IS UNIQUE OBJECT
        if (this.dataParent.storage.productData.interface.panels[objectType].restrict.unique === true) {
            return this.dataParent.class.Canvas.getObject(canvasName, this.dataParent.storage.productData.interface.panels[objectType].restrict.objectName, this.dataParent.storage.productData.interface.panels[objectType].restrict.objectType);
        } else if (canvasName.getActiveObject() === null) {
            console.log("getObjectSystem function : (canvasName.getActiveObject() === null" + objectType);

            return false;
        }
        return canvasName.getActiveObject();
    };

    setObject(obj, options) {
        console.log("[setObject]", obj, options);
        if (obj !== false) {
            obj.set(options);
            obj.setCoords();
            console.log('this.dataParent.storage.canvas', this.dataParent.storage.canvas);
            this.dataParent.storage.canvas.renderAll();
            if (!options.angle) {
                this.dataParent.class.Canvas.setStepJsonCanvas();
            }
        } else {
            console.log("setObject : obj inexistant");
            var options = [];
            //options.message = "Pour modifier un objet de type «" + this.dataParent.class.Dom.getActiveTab("lang") + "», vous devez en séléctionner un.";
            options.message = "Objet non trouvé sur cette étape. Sélectionnez-le pour l'activer.";

            this.dataParent.class.Dom.messageAlert(options);
            console.log(" function");
        }
    };

    getTexteCeintureSlogan(fileNameImg) {
        let slogan = 'SAISIR VOTRE TEXTE';
        $.each(this.dataParent.storage.arr_slogan.images, (i, v) => {
            if (v.name === fileNameImg) {
                // console.log("=)=============="+fileNameImg);
                slogan = v.slogan;
            }
        });
        return slogan;
    };


    moveToTopObject(canvasName, ObjectName, ObjectType) {
        console.log("[moveToTopObject] on step " + canvasName.step, ObjectName, ObjectType);
        const dataParent = this.dataParent;
        const objects = canvasName.getObjects();
        //console.log('Objects of canvasName', objects);
        let findedObject = false;
        objects.forEach(function (o) {
            //console.log("liste :" + o.name + " -> objet recherché :" + ObjectName);
            //console.log("liste & objet recherché :" + ObjectName, o);
            //if (o.name == ObjectName) {
            if (o.name == ObjectName && o.objectType == ObjectType) {
                canvasName.bringToFront(dataParent.class.Canvas.getObject(canvasName, ObjectName, ObjectType));
                findedObject = true;
                console.log("bringToFront object finded : " + o.objectType + " " + o.name + " ", dataParent.class.Canvas.getObject(canvasName, ObjectName, ObjectType));
            }
        });
        if (findedObject === false) {
            console.log('*** Object not finded : ' + ObjectName, objects);
        }
    };



    setTextInputOnCanvas(text, canvasName) {
        console.log('[setTextInputOnCanvas] ' + text);
        if (this.dataParent.storage.productData.interface.panels.text.restrict.uppercase === true) {
            text = text.toUpperCase();
        }

        let left = canvasName.width / 2;
        let top = canvasName.height / 2;
        if (Boolean(this.dataParent.storage.productData.interface.panels.text.restrict.centerOnObject) !== false) {
            console.log('centerOnObject != false ', this.dataParent.storage.productData.interface.panels.text.restrict.centerOnObject);
            console.log('#### erreur', this.dataParent.storage.productData.interface.panels.text.restrict.centerOnObject, this.dataParent.storage.productData.interface.panels.text.restrict.objectType);
            const centerOnObjectName = this.dataParent.class.Canvas.getObject(canvasName, this.dataParent.storage.productData.interface.panels.text.restrict.centerOnObject, 'ceinture');
            console.log('#### centerOnObjectName', centerOnObjectName);
            left = centerOnObjectName.getCenterPoint().x;
            top = centerOnObjectName.getCenterPoint().y;
        }

        const textObjectOptions = {
            fill: this.dataParent.storage.productData.interface.panels.text.restrict.colorText,
            textAlign: 'center',
            left,
            top,
            originX: 'center',
            originY: 'center',
            fontSize: this.dataParent.storage.productData.interface.panels.text.restrict.fontsize,
            centeredScaling: true,
            id: '30',
            name: this.dataParent.storage.productData.interface.panels.text.restrict.objectName,
            objectType: 'text',
            centerOnObject: this.dataParent.storage.productData.interface.panels.text.restrict.centerOnObject,
            hasControls: this.dataParent.storage.productData.interface.panels.text.restrict.hasControls,
            layer: 30,
            stroke: this.dataParent.storage.productData.interface.panels.text.restrict.strokeColor,
            strokeWidth: this.dataParent.storage.productData.interface.panels.text.restrict.strokeWidth,
            strokeUniform: false,
            lockMovementX: this.dataParent.storage.productData.interface.panels.text.restrict.lockMovementX,
            lockMovementY: this.dataParent.storage.productData.interface.panels.text.restrict.lockMovementY,
            lockRotation: this.dataParent.storage.productData.interface.panels.text.restrict.lockRotation,
            lockScalingX: this.dataParent.storage.productData.interface.panels.text.restrict.lockScalingX,
            lockScalingY: this.dataParent.storage.productData.interface.panels.text.restrict.lockScalingY,
            lockUniScaling: this.dataParent.storage.productData.interface.panels.text.restrict.lockUniScaling,
            //transparentCorners: false,
            //cornerStyle: 'circle',
            borderColor: '#222222',
            //cornerSize: 15,
            //cornerColor: '#222222',
            //cornerShape: 'circle',
            cornerBackgroundColor: '#222222',
            cornerStrokeColor: '#000',
            editable: this.dataParent.storage.productData.interface.panels.text.restrict.editable,
            scaleX: canvasName.width / 2745,
            scaleY: canvasName.height / 1769,
            scaleXOriginal: canvasName.width / 2745,
            scaleYOriginal: canvasName.height / 1769,
            selectable: this.dataParent.storage.productData.interface.panels.text.restrict.selectable,
        };
        console.log('textObjectOptions', textObjectOptions);

        if ((this.dataParent.class.Canvas.getObject(canvasName, this.dataParent.storage.productData.interface.panels.text.restrict.objectName, this.dataParent.storage.productData.interface.panels.text.restrict.objectType) === false && this.dataParent.storage.productData.interface.panels.text.restrict.unique === true)
            || this.dataParent.storage.productData.interface.panels.text.restrict.unique === false) {
            const obj_texte_ceinture = new fabric.IText(text, textObjectOptions);
            canvasName.add(obj_texte_ceinture);
            console.log('this.dataParent.storage.tabActive', this.dataParent.storage.tabActive);
            if (this.dataParent.storage.productData.interface.panels[this.dataParent.storage.tabActive].restrict.setControlsVisibility === true) {
                obj_texte_ceinture.setControlsVisibility(this.dataParent.storage.HideControls);
            } else {
                obj_texte_ceinture.setControlsVisibility(this.dataParent.storage.HideControlsAll);
            }
            this.dataParent.class.Canvas.moveToTopObject(canvasName, this.dataParent.storage.productData.interface.panels.text.restrict.objectName, this.dataParent.storage.productData.interface.panels.text.restrict.objectType);
            obj_texte_ceinture.setCoords();
        }

        // UPDATE OBJECT
        const object = this.dataParent.class.Canvas.getObject(canvasName, this.dataParent.storage.productData.interface.panels.text.restrict.objectName, this.dataParent.storage.productData.interface.panels.text.restrict.objectType);
        console.log('upd object text', this.dataParent.storage.productData.interface.panels.text.restrict.objectName, object);
        this.dataParent.class.Canvas.setObject(object, {
            text,
        });


        $('#insert-txt').html('Modifier');
        //this.dataParent.class.Dom.activeItemsAction('text');
        if (this.dataParent.storage.productData.interface.panels.text.restrict.unique === true) {
            $('#insert-txt-btn')
                .find('span')
                .addClass('edit-text')
                .removeClass('add-text');
            $('#input_txt_ceinture').val(text);
        } else {
            $('#input_txt_ceinture').val('');
        }

        //canvasName.optionsSelling.belt.use = true;
        //canvasName.optionsSelling.belt.sell = this.dataParent.storage.productData.interface.optionsselling.belt.sell;
    };

    isSitcker(obj) {
        if (obj !== null && typeof obj.name !== "undefined" && obj.name.indexOf("fabricObj_sticker") > -1) {
            return true;
        }
        return false;
    };

    setBackgroundImgToCanvas(canvasName, options) {
        console.log('setBackgroundImgToCanvas', options);
        options.load = 'fromUrl';
        if (options.library === 0) {
            options.load = 'onLoad';
        }


        const dataParent = this.dataParent;
        this.dataParent.class.Canvas.loadImg(options.imgSrc, options.load, (Img, nameLoading) => {
            if (options.library === '1') {
                $('#imageLoader').val('');
                $('#img_interne')
                    .find('.clipart-element')
                    .removeClass('clipart-element')
                    .addClass('clipart-element-disabled');
            }

            if (dataParent.storage.productData.interface.panels.picture.restrict.unique === true) {
                console.log('restrict unique fabricObj_fond so remove old background');
                dataParent.class.Canvas.removeObject(canvasName, 'fabricObj_fond');
            }

            const idealWidth = 2745;
            const idealHeight = 1769;
            const imgWidth = Img.width;
            const imgHeight = Img.height;
            const ratioWidth = imgWidth / idealWidth;
            const ratioHeight = imgHeight / idealHeight;

            console.log('imgWidth', imgWidth);
            console.log('imgHeight', imgHeight);

            console.log('ratioWidth', ratioWidth);
            console.log('ratioHeight', ratioHeight);

            let ratioFinal = ratioWidth;
            if (ratioWidth > ratioHeight) {
                ratioFinal = ratioHeight;
            }
            console.log('ratioFinal', ratioFinal);
            let scaleX = (1 / 7.07) * dataParent.storage.SCALE_FACTOR;
            let scaleY = (1 / 7.07) * dataParent.storage.SCALE_FACTOR;
            if (ratioFinal >= 1) {
                scaleX = (1 / ratioFinal / 7.07) * dataParent.storage.SCALE_FACTOR;
                scaleY = (1 / ratioFinal / 7.07) * dataParent.storage.SCALE_FACTOR;
            }
            console.log('scaleX', scaleX);
            console.log('scaleY', scaleY);
            scaleX = 0.24144271570014144;
            scaleY = 0.24144271570014144;
            // scaleX = 1;
            // scaleY = 1;
            let left = 0;
            left = canvasName.width / 2;
            const top = canvasName.height / 2 + 20;
            const angle = 0;
            const animateStartEnd = canvasName.width / 2;

            const ImgOptions = {
                angle,
                borderColor: '#222222',
                centeredRotation: true,
                centeredScaling: true,
                //cornerStyle: 'circle',
                //cornerSize: 15,
                //cornerColor: '#222222',
                //cornerShape: 'circle',
                cornerBackgroundColor: '#222222',
                cornerStrokeColor: '#000',
                hasControls: dataParent.storage.productData.interface.panels.picture.restrict.hasControls,
                hasRotatingPoint: dataParent.storage.productData.interface.panels.picture.restrict.hasRotatingPoint,
                id: '10',
                left,
                library: options.library,
                libraryName: options.libraryName,
                lockMovementX: dataParent.storage.productData.interface.panels.picture.restrict.lockMovementX,
                lockMovementY: dataParent.storage.productData.interface.panels.picture.restrict.lockMovementY,
                lockRotation: dataParent.storage.productData.interface.panels.picture.restrict.lockRotation,
                lockScalingX: dataParent.storage.productData.interface.panels.picture.restrict.lockScalingX,
                lockScalingY: dataParent.storage.productData.interface.panels.picture.restrict.lockScalingY,
                lockUniScaling: true,
                minScaleLimit: 0.001,
                name: dataParent.storage.productData.interface.panels.picture.restrict.objectName,
                objectType: dataParent.storage.productData.interface.panels.picture.restrict.objectType,
                opacity: 1,
                originX: 'center',
                originY: 'center',
                scaleX,
                scaleY,
                scaleXOriginal: scaleX,
                scaleYOriginal: scaleY,
                // selectable: productData.interface.panels.picture.restrict.selectable,
                textAlign: 'center',
                top,
                //transparentCorners: false,
            };

            console.log('ImgOptions', ImgOptions);

            Img.set(ImgOptions);
            //console.log(`tabActive ->${dataParent.storage.tabActive}`);


            console.log('==== restirct ===', dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict)
            /*dataParent.storage.canvasWidth = ($('#wrapper_custom').width() * 0.75) / 2745;
            if (dataParent.storage.verticalOrientation === true) {
                dataParent.storage.canvasWidth = $('#wrapper_custom').width() / 2745;
            }*/
            console.log('canvasName.width', canvasName.width);
            let add5percentsize = (canvasName.width * 15) / 100;
            console.log('add5percentsize', add5percentsize);

            dataParent.storage.canvasWidth = (canvasName.width + add5percentsize) / 2745;
            console.log('dataParent.storage.canvasWidth ', dataParent.storage.canvasWidth);

            let finalScale = dataParent.storage.canvasWidth;
            console.log('finalscale', finalScale);
            if (options.library === 'ia') {
                finalScale = finalScale + ((finalScale * 30) / 100);
                console.log('finalscale ia', finalScale);
            }

            Img.set({
                scaleX: finalScale,
                scaleY: finalScale,
                scaleXOriginal: finalScale,
                scaleYOriginal: finalScale,
            });


            if (dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.setControlsVisibility === false) {
                Img.setControlsVisibility(dataParent.storage.HideControlsAll);
            }
            else {
                Img.setControlsVisibility(dataParent.storage.HideControls);
            }
            /*Img.animate("left", animateStartEnd, {
                onChange: canvasName.renderAll.bind(canvasName),
                duration: 500,
                easing: fabric.util.ease.easeOutQuart,
            });*/
            canvasName.add(Img);
            canvasName.centerObject(Img);
            Img.setCoords();
            /* if (canvasName.optionsSelling.image.active == true) {
                canvasName.optionsSelling.image.use = true;
            } */

            // canvasName.setActiveObject(Img);

            canvasName.requestRenderAll();
            canvasName.bringToFront(dataParent.class.Canvas.getObject(canvasName, 'fabricObj_belt', 'ceinture'));
            canvasName.bringToFront(dataParent.class.Canvas.getObject(canvasName, 'fabricObj_text', 'text'));
            dataParent.class.Canvas.bringToFrontGroup('fabricObj_sticker', canvasName);

            //            canvasName.renderAll();

            if (options.library === '1') {
                $('#img_interne')
                    .find('.clipart-element-disabled')
                    .removeClass('clipart-element-disabled')
                    .addClass('clipart-element');
            }

            /* let my_range = $("#picture-zoom").data("ionRangeSlider");
             my_range.update({
             from: 0
             }); */

            $('#picture-zoom').val('0');
            $('#picture-angle').val('0');
            /* if (productData.interface.panels.picture.restrict.unique === true)
             {
             //$('#zoom-panel').attr('data-origin-zoom', parseInt(object.scaleX * 1000));
             $('#picture-zoom').attr('min', parseInt((Img.scaleXOriginal * 1000) / 2));
             $('#picture-zoom').attr('max', parseInt((Img.scaleXOriginal * 1000) * 2));
             $('#picture-zoom').val(parseInt(Img.scaleX * 1000));
             console.log('VALUE actuelle :' + parseInt(Img.scaleX * 1000));
             } */

            //dataParent.class.Dom.commandBtnUpdate(canvasName);
            dataParent.class.Dom.activeItemsAction(dataParent.storage.tabActive);
            unloadingView(nameLoading);
        });
    };


    setCanvas(canvasName, options) {
        console.log('[setCanvas]', canvasName, options, this.dataParent.storage.stepJsonCanvas);
        if (canvasName !== false) {
            canvasName.set(options);
            //console.log('setCanvas()2', canvasName, options, this.dataParent.storage.stepJsonCanvas);
            //this.dataParent.class.Canvas.setStepJsonCanvas();
            //console.log('setCanvas()3', canvasName, options, this.dataParent.storage.stepJsonCanvas);

        } else {
            console.log("setCanvas : canvasName inexistant");
        }
    };



    addToCanvas(url, canvasName) {
        const dataParent = this.dataParent;
        dataParent.class.Canvas.setBackgroundImgToCanvas(dataParent.storage.canvas, {
            imgSrc: url,
            library: 'ia',
            libraryName: '',
        });
    }



    loadImg(imgSrc, method, callback) {
        loadingView(
            "personnalisation_image",
            "create.svg",
            "Chargement de l'image...",
            null,
            function (nameLoading) {
                //console.log("method" + method);
                if (method === "onLoad") {
                    var imgObj = new Image();
                    imgObj.onload = function () {
                        console.log("callback de image !");
                        var Img = new fabric.Image(imgObj);

                        callback(Img, nameLoading);
                    };
                    imgObj.src = imgSrc;
                } else if (method === "fromUrl") {
                    console.log("src from url : " + imgSrc);
                    fabric.Image.fromURL(imgSrc, function (Img) {
                        callback(Img, nameLoading);
                    });
                }
            }
        );
    };



    removeAllObjects(canvasName) {
        canvasName.getObjects().forEach(function (o) {
            canvasName.remove(o);
        });
    }

    removeObjectType(canvasName, objectType) {
        console.log("[RemoveObjectType] : " + objectType);

        const objects = canvasName.getObjects();
        console.log('objects of canvas', objects);
        objects.forEach(function (o) {
            if (o.objectType == objectType) {
                canvasName.remove(o);
                console.log("Object by objectType : " + o.objectType + " removed.");
            }
        });
    };

    removeObject(canvasName, ObjectName, objectType) {
        console.log("[RemoveObject] : " + ObjectName);
        //console.log(this.dataParent.storage.ObjectLess.indexOf(typeof canvasName.getActiveObject()));

        if (ObjectName) {
            //console.log("ObjectName OK");
            canvasName.getObjects().forEach(function (o) {
                if (o.name == ObjectName) {
                    canvasName.remove(o);
                    console.log("Objet : " + o.name + " retiré Ok");
                    //console.log(o);
                }
            });
        } else if (this.dataParent.storage.ObjectLess.indexOf(typeof canvasName.getActiveObject()) === -1 && canvasName.getActiveObject() !== null) {
            //var canvasName.getActiveObject().get('name');
            console.log(canvasName.getActiveObject());
            let objectType = canvasName.getActiveObject().get("objectType");
            canvasName.remove(canvasName.getActiveObject());

            if (this.dataParent.storage.productData.interface.panels.text.restrict.unique === false) {
                $(".item_" + objectType).addClass("offline");
                console.log(
                    "############################### OFFLINE .item_" + objectType
                );
                $("#boxercolors").removeClass("offline");
                $("#download").removeClass("offline");
            }
        } else {
            console.log(this.dataParent.storage.tabActive);
            console.log(this.dataParent.storage.productData.interface.panels[this.dataParent.storage.tabActive]);
            if (this.dataParent.storage.productData.interface.panels[this.dataParent.storage.tabActive].restrict.unique === true) {
                let object = getObjectSystem(canvasName, this.dataParent.storage.tabActive);
                console.log(object);
                canvasName.remove(object);
            }
            messageAlert({
                message: "Vous devez sélectionner votre objet pour le supprimer.",
            });
        }
    };


    setCanvasTmp(jsonCanvas) {
        console.log('[setCanvasTmp] {jsonCanvas}', jsonCanvas);

        const dataParent = this.dataParent;
        return new Promise(function (resolve, reject) {
            /*loadingView(
                "setCanvasTmp",
                "create.svg",
                "Chargement ...",
                null
            );*/
            console.log('setcanvastmp storage.canvas', dataParent.storage.canvas);
            // LOAD NEW CANVAS
            //$('#load-template').attr('data-id_step', step_click);

            //$('#steps').find('.swiper-slide').removeClass('active');
            //$('#steps').find(`.swiper-slide.step_${step_click}`).addClass('active');


            /*dataParent.class.Canvas.setCanvas(dataParent.storage.canvas, {
                step: step_click,
            });*/
            dataParent.storage.canvas.clone(function (canvastmp) {
                jsonCanvas = JSON.stringify(jsonCanvas);
                //console.log('[loadStepJsonCanvas] STEP  ' + step_click + ' already exist -> loadfromjson', jsonCanvas);
                const result = canvastmp.loadFromJSON(jsonCanvas, function () {
                    console.log(' for step ', canvastmp.step);
                    dataParent.class.Canvas.moveToTopObject(canvastmp, 'fabricObj_belt', "ceinture");
                    dataParent.class.Canvas.moveToTopObject(canvastmp, 'fabricObj_text', "text");
                    canvastmp.renderAll.bind(canvastmp);
                    //unloadingView('setCanvasTmp');
                    console.log('[setCanvasTmp] fin => stepJsonCanvas ', dataParent.storage.stepJsonCanvas);
                    resolve(canvastmp);
                });
            },
                [
                    "id",
                    "name",
                    "library",
                    "libraryName",
                    "hasRotatingPoint",
                    "hasControls",
                    "_controlsVisibility",
                    "minScaleLimit",
                    "scaleX",
                    "scaleY",
                    "lockMovementX",
                    "lockMovementY",
                    "lockRotation",
                    "lockScalingX",
                    "lockScalingY",
                    "lockUniScaling",
                    "overlayImage",
                    "filters",
                    "resizeFilters",
                    "optionsSelling",
                    "objectType",
                    "nbstep",
                    "step",
                    "numOverlay"
                ]);
        });
    }

    async setColorText(fillColor) {
        console.log('[setColorText]');
        const object = this.dataParent.class.Canvas.getObject(this.dataParent.storage.canvas, 'fabricObj_text', 'text');
        console.log('object to color', object);
        this.dataParent.class.Canvas.setObject(object, {
            fill: fillColor,
        });
        for (var step = 1; step <= this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive][1].nbstep; step++) {
            // load canvastmp
            const canvastmp = await this.dataParent.class.Canvas.setCanvasTmp(this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive][step]);
            // change belt color
            this.dataParent.class.Canvas.setObject(this.dataParent.class.Canvas.getObject(canvastmp, 'fabricObj_text', 'text'), {
                fill: fillColor,
            });
            // update all canvas
            this.dataParent.class.Canvas.setStepJsonCanvas(canvastmp, step, true);
        }
    }

    async setColorBelt(fillColor) {
        console.log('[setColorBelt]', fillColor);

        const object = this.dataParent.class.Canvas.getObject(this.dataParent.storage.canvas, 'fabricObj_belt', 'ceinture');
        console.log('object to color', object);
        this.dataParent.class.Canvas.setObject(object, {
            fill: fillColor,
        });

        // const object = this.dataParent.class.Canvas.setObject(this.dataParent.class.Canvas.getObject(this.dataParent.storage.canvas, 'fabricObj_belt', 'ceinture');
        // this.dataParent.class.Canvas.setObject(object, {
        //     fill: fillColor,
        // });
        for (var step = 1; step <= this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive][1].nbstep; step++) {
            // load canvastmp
            const canvastmp = await this.dataParent.class.Canvas.setCanvasTmp(this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive][step]);
            // change belt color
            this.dataParent.class.Canvas.setObject(this.dataParent.class.Canvas.getObject(canvastmp, 'fabricObj_belt', 'ceinture'), {
                fill: fillColor,
            });
            // update all canvas
            this.dataParent.class.Canvas.setStepJsonCanvas(canvastmp, step, true);
        }
    }

    async loadStepJsonCanvas(step_click) {
        console.log('[loadStepJsonCanvas]', step_click);


        //console.log('this.dataParent.storage.stepJsonCanvas', this.dataParent.storage.stepJsonCanvas);
        // console.log('this.dataParent.storage.canvas', this.dataParent.storage.canvas);
        loadingView(
            "loadStepJsonCanvas",
            "create.svg",
            "Chargement de l'étape...",
            null
        );
        const dataParent = this.dataParent;
        return new Promise(function (resolve, reject) {


            // LOAD NEW CANVAS
            $('#load-template').attr('data-id_step', step_click);

            $('#steps').find('.swiper-slide').removeClass('active');
            $('#steps').find(`.swiper-slide.step_${step_click}`).addClass('active');

            if (typeof dataParent.storage.stepJsonCanvas[dataParent.storage.idProductActive][step_click] !== 'undefined') {
                dataParent.class.Canvas.setCanvas(dataParent.storage.canvas, {
                    step: step_click,
                });

                const jsonCanvas = JSON.stringify(dataParent.storage.stepJsonCanvas[dataParent.storage.idProductActive][step_click]);

                const result = dataParent.storage.canvas.loadFromJSON(jsonCanvas, function () {
                    console.log('loadFromJSON canvas step' + step_click);
                    dataParent.class.Canvas.moveToTopObject(dataParent.storage.canvas, 'fabricObj_belt', "ceinture");
                    dataParent.class.Canvas.moveToTopObject(dataParent.storage.canvas, 'fabricObj_sticker', "txtsmiley");
                    dataParent.class.Canvas.moveToTopObject(dataParent.storage.canvas, 'fabricObj_text', "text");
                    dataParent.storage.canvas.renderAll.bind(dataParent.storage.canvas);
                    unloadingView('loadStepJsonCanvas');
                    resolve('1440');
                });

            } else {
                console.log('[loadStepJsonCanvas] STEP ' + step_click + ' NO EXIST');
                unloadingView('loadStepJsonCanvas');
                // ASK IF DUPLICATE STEP ONE ON THIS STEP
                console.log('dataParent.storage', dataParent.storage.productData.interface.steps.stepname[step_click]);
                iziToast.question({
                    timeout: false,
                    transitionIn: false,
                    transitionOut: false,
                    transitionInOverlay: false,
                    transitionOutOverlay: false,
                    theme: 'dark',
                    color: '#fff',
                    class: 'custom_izitoast',
                    backgroundColor: '#222',
                    close: false,
                    maxWidth: '500px',
                    overlay: true,
                    displayMode: 'once',
                    id: 'question',
                    zindex: 999,
                    message: `<b>Que voulez-vous pour : ${dataParent.storage.productData.interface.steps.stepname[step_click]} ?</b>`,
                    position: 'center',
                    buttons: [
                        [
                            "<button>Je veux <b>la même</b> personnalisation</button>", function (instance, toast) {
                                instance.hide({ transitionOut: 'fadeOut', }, toast, 'same');
                            },
                            true,
                        ],
                        [
                            "<button>Je veux <b>une autre</b> personnalisation</button>", function (instance, toast) {
                                instance.hide({ transitionOut: 'fadeOut', }, toast, 'new');
                            },
                            true,
                        ],
                    ],
                    onClosed: function (instance, toast, closedBy) {
                        console.info('Closed | closedBy: ' + closedBy);
                        dataParent.storage.notice.allstep = false;

                        if (closedBy === 'new') {
                            dataParent.class.Canvas.setCanvas(dataParent.storage.canvas, {
                                step: step_click,
                            });
                            dataParent.storage.canvas.clear();
                            dataParent.class.Canvas.setOverlay(1, dataParent.storage.canvas);
                            dataParent.class.Dom.updItems(dataParent.storage.tabActive);
                            resolve('new');

                        }
                        else {
                            dataParent.class.Canvas.setCanvas(dataParent.storage.canvas, {
                                step: step_click,
                            });
                            console.log('dataParent.storage.canvas', dataParent.storage.canvas);
                            dataParent.class.Canvas.setOverlay(dataParent.storage.canvas.numOverlay, dataParent.storage.canvas);
                            dataParent.class.Canvas.setStepJsonCanvas();
                            dataParent.class.Dom.updItems(dataParent.storage.tabActive);
                            console.log('fin loadStepJsonCanvas this.dataParent.storage.stepJsonCanvas', dataParent.storage.stepJsonCanvas);
                            resolve('same');
                        }
                    }
                });

            }
            dataParent.storage.canvas.step = step_click;
            dataParent.class.Dom.updItems(dataParent.storage.tabActive);
            console.log('after Promise ?');

            // UPD INPUT FILES VIEW FOR PHOTO
            $('label.input-file-trigger').css({
                'visibility': 'hidden',
                'display': 'none'
            });

            $('label[for="imageLoader_' + dataParent.storage.canvas.step + '"]').css({
                'visibility': 'visible',
                'display': 'flex'
            });

            $('#swiper-container-picture').find('*').filter(function () {
                return /bloc-column_\d+$/.test($(this).attr('class'));
            }).css({
                display: 'none'
            });

            $(`.bloc-column_${dataParent.storage.canvas.step}`).css({
                display: 'flex'
            });

        });
    };


    deleteBeltbackgroundColor(canvasName) {
        console.log('[deleteBeltbackgroundColor]');
        var fabricObj_belt = this.dataParent.class.Canvas.getObject(canvasName, "fabricObj_belt", "ceinture");
        console.log('fabricObj_belt exist?', fabricObj_belt);
        if (fabricObj_belt !== false) {
            fabricObj_belt.set('fill', '#222222');
        }

    }

    initBackgroundColor(canvasName) {
        console.log('[initBackgroundColor]');
        this.dataParent.class.Canvas.setCanvas(canvasName, {
            backgroundColor: this.dataParent.storage.productData.interface.backgroundcolor,
        });
    };
    addBackgroundColor(canvaName, color) {
        console.log('[addBackgroundColor]');
        this.setCanvas(canvaName, {
            backgroundColor: color,
        });
        this.dataParent.class.Canvas.setStepJsonCanvas();
        console.log("addBackgroundColor", this.dataParent.storage);
    };

    async setStepThumb(idProduct, step) {
        console.log('[setStepThumb]', idProduct, step);
        const dataParent = this.dataParent;

        return new Promise(function (resolve, reject) {
            (async () => {
                if (step === undefined) {
                    for (let i = 1; i <= dataParent.storage.productData.interface.steps.nbstep; i++) {
                        const canvastmp = await dataParent.class.Canvas.setCanvasTmp(dataParent.storage.stepJsonCanvas[idProduct][i]);
                        await new Promise(function (resolve, reject) {
                            dataParent.storage.thumbs[dataParent.storage.idProductActive][i] = canvastmp.toDataURL({
                                format: 'jpg',
                                quality: 0.6,
                            });
                            //$('#testcanvas').append(`<img class="thumb_${i}" src="${dataParent.storage.thumbs[dataParent.storage.idProductActive][i]}"  />`);
                            resolve();
                        });
                    };
                }
                else {
                    const canvastmp = await dataParent.class.Canvas.setCanvasTmp(dataParent.storage.stepJsonCanvas[idProduct][step]);
                    await new Promise(function (resolve, reject) {
                        dataParent.storage.thumbs[dataParent.storage.idProductActive][step] = canvastmp.toDataURL({
                            format: 'jpg',
                            quality: 0.6,
                        });
                        resolve();
                    });
                }
                resolve();
            })();
        });
    }



    async jsonSaveCanvasDB(canvasName, idProduct, attributesQty) {
        console.log("[jsonSaveCanvasDB]");

        console.log('dataParent.storage.stepJsonCanvas before save & before stepThumb' + idProduct, this.dataParent.storage.stepJsonCanvas);

        const dataParent = this.dataParent;
        const res = await this.dataParent.class.Canvas.setStepThumb(idProduct);

        unloadingView("customLoading");
        // Afficher la barre de progression avant de démarrer l'ajax
        // console.log('show bar');
        // $(document).find('.progress-container').show(); // On rend la barre visible
        // $("#progressText").text("Enregistrement en cours..."); // Mettre un texte si besoin

        // Configuration de la barre de progression
        if ($('.progress-container').length) {
            console.log('progress container for datas exist')
            $('#SummaryText').text('Sauvegarde du projet...');
        }
        else {
            console.log('progress container NOT exist')
        }
        const $progressContainer = $('.progress-container');
        const $progressBar = $('#uploadProgress');
        const $progressText = $('#progressText');

        // Initialiser la barre de progression et la rendre visible
        $progressContainer.show();
        $progressBar.val(0);
        $progressText.text('0%');



        const result = await $.ajax({
            type: "POST",
            // async: false,
            url: prestashop.urls.base_url + "modules/personnalisation/action.php",
            dataType: "json",
            data: {
                cache: false,
                method: "canvas_save_ajax",
                token: prestashop.static_token,
                idProduct: idProduct,
                attributesQty: attributesQty,
                blockui_img: "create.svg",
                blockui_message: "Sauvegarde du projet...",
                blockui_name: "ajax_save_canvas_db",
                thumbs: dataParent.storage.thumbs[idProduct],
                step: dataParent.storage.canvas.step,
                stepJsonCanvas: JSON.stringify(dataParent.storage.stepJsonCanvas[idProduct]),
            },
            xhr: function () {
                const xhr = $.ajaxSettings.xhr();
                if (xhr.upload) {
                    xhr.upload.addEventListener('progress', function (event) {
                        if (event.lengthComputable) {
                            const percentComplete = (event.loaded / event.total) * 100;
                            $progressBar.val(percentComplete);
                            $progressText.text(`${Math.round(percentComplete)}%`);
                            console.log(`Progression : ${Math.round(percentComplete)}%`);
                        }
                    }, false);
                }
                return xhr;
            },
            success: function (json) {
                console.log("retour ajax success jsonSaveCanvasDB");
                console.log(json);
                if (json.success === false) {
                    alert('Un problème de sauvegarde est survenu.');
                }

            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error('AJAX Error:', {
                    status: jqXHR.status,
                    statusText: jqXHR.statusText,
                    responseText: jqXHR.responseText,
                    errorThrown: errorThrown
                });
                alert(`Erreur AJAX\nStatus: ${jqXHR.status}\nText: ${textStatus}\nError Thrown: ${errorThrown}`);
            },
            complete: function () {
                // unloadingView("customLoading");
                $progressContainer.hide();
                // $(".progress-container").hide(); // Masquer la barre de progression après l'ajax
            }
        });
        return result;
    }



    jsonLoadCanvasDB(data) {
        console.log("[jsonLoadCanvas function]: " + data.id_personnalisation);
        loadingView(
            "chargement_canvas",
            "create.svg",
            "Chargement du canvas client..",
            null
        );

        return $.ajax({
            type: "POST",
            async: false,
            url: baseDir + "modules/personnalisation/action.php",
            data: {
                method: "canvas_load_ajax",
                canvas_load_ajax: data,
                blockui_img: "personnalisation-chargement.gif",
                blockui_message: "Chargement de votre projet..",
            },
            success: function (json) {
                // CREATE IMG THUMB
                //console.log('jsonLoadCanvasDB', json);
                //$('#id_personnalisation').val(json.id_personnalisation);
                //id_personnalisation = json.id_personnalisation;
                //unloading("save_projet_client");
            },
        });
    };


    getTextFromObject(canvasName, ObjectName) {
        var findedText = false;
        canvasName.getObjects().forEach(function (o) {
            //console.log("liste :"+o.name+" -> objet recherché :"+ObjectName);
            //console.log(o);
            if (o.name == ObjectName && o.text) {
                //console.log("Objet : " + o.name + " get text => " + o.text + "  Ok");
                findedText = o.text;
            }
        });
        return findedText;
    };

    testTexteCeintureOriginal() {
        return this.dataParent.class.Canvas.compareTextObject(this.dataParent.storage.canvas, 'fabricObj_text', 'SAISIR VOTRE TEXTE');
    };

    testTexteCeintureSlogan(fileNameImg) {

        let isTexteCeintureSlogan;

        $.each(this.dataParent.storage.arr_slogan.images, (i, v) => {
            //const slogan = v.slogan.toUpperCase();
            if (v.slogan === this.dataParent.class.Canvas.getTextFromObject(this.dataParent.storage.canvas, 'fabricObj_text')) {
                isTexteCeintureSlogan = true;
            }
        });
        return isTexteCeintureSlogan;
    };


    compareTextObject(canvasName, ObjectName, value) {
        console.log('[getTextObject function]');
        let findedText = false;
        canvasName.getObjects().forEach((o) => {
            // console.log("liste :"+o.name+" -> objet recherché :"+ObjectName);
            if (o.name == ObjectName && o.text == value) {
                console.log(
                    `Objet : ${o.name} compare text => ${o.text}  Ok`,
                );
                findedText = true;
            }
        });
        return findedText;
    };

    bringToFrontGroup(searchString, canvasName) {
        //        console.log(canvasName.getObjects());
        canvasName.getObjects().forEach(function (o) {
            var name = o.name;
            //console.log('search  bringToFront: ' + name);
            if (name.indexOf(searchString) > -1) {
                //console.log('try bringToFront');
                //console.log(o);
                canvasName.bringToFront(o);
            }
        });
    };


    getObject(canvasName, ObjectName, ObjectType) {
        //console.log("[getObject]");
        let getObjectValue = false;
        //console.log(canvasName);
        //console.log(canvasName.getObjects());
        canvasName.getObjects().forEach(function (o) {
            // console.log('forEach object', o);
            const name = o.name;
            const typeObject = o.objectType;
            // console.log('ObjectName arg:' + ObjectName);
            // console.log('ObjectType arg:' + ObjectType);
            // console.log('o.name:' + name);
            // console.log('o.name.indexOf(ObjectName):' + name.indexOf(ObjectName));
            // console.log('o.ObjectType:' + typeObject);
            // console.log('o.typeObject.indexOf(ObjectType):' + typeObject.indexOf(ObjectType));

            if ((name !== undefined && name.indexOf(ObjectName) > -1) && (ObjectType !== undefined && typeObject.indexOf(ObjectType) > -1)) {
                // console.log("getObject with objectType  : " + name + " finded. " + typeObject + " finded.");
                getObjectValue = o;
            }
            // else if (name !== undefined && name.indexOf(ObjectName) > -1 && ObjectType === undefined) {
            //     console.log("getObject without objectType : " + o.name + " finded.");
            //     getObjectValue = o;
            // }
        });
        //console.log('return getObject getObjectValue', getObjectValue);
        return getObjectValue;
    };

    getObjectFeature(canvasName, ObjectFeature) {
        //console.log(canvasName);
        var getObject = false;

        canvasName.getObjects().forEach(function (o) {
            //console.log('*****OBJECTTYPE : ' + o.objectType);
            if (o.objectType && o.objectType == ObjectFeature) {
                //                console.log("getObject : " + o.name + " selectionné Ok");
                getObject = o;
            }
        });
        return getObject;
    };

    percentageObject(object, canvasName) {
        var OriginalWidth = object.width;

        //console.log(object);

        var TailleCanvas = object.width * object.scaleXOriginal;
        var RatioReductionImgVersCanvas = TailleCanvas / OriginalWidth;
        var percent = parseInt((object.scaleX * 100) / RatioReductionImgVersCanvas);
        /*console.log(RatioReductionImgVersCanvas);
        console.log("OriginalWidth : " + OriginalWidth);
        console.log("TailleCanvas : " + TailleCanvas);
        console.log("RatioReductionImgVersCanvas : " + RatioReductionImgVersCanvas);
        console.log("percent : " + percent);*/
        return {
            RatioReductionImgVersCanvas: RatioReductionImgVersCanvas,
            pourcentage: percent,
        };
    };

    ratioMax(RatioReductionImgVersCanvas, ratio) {
        return RatioReductionImgVersCanvas * ratio;
    };

    disableScroll(canvasName) {
        canvasName.allowTouchScrolling = false;
    };

    enableScroll(canvasName) {
        canvasName.allowTouchScrolling = true;
    };

    onCanvasMouseUp(e) {
        console.log("# onCanvasMouseUp");
        var selectedObject = e.target;
        if (selectedObject === null) {
            return false;
        }
        //this.dataParent.class.Canvas.editOnClones(e.target);
        this.dataParent.class.Canvas.enableScroll(selectedObject);
    };
    onCanvasMouseDown(e) {
        var selectedObject = e.target;
        console.log("# onCanvasMouseDown");
        //console.log(e);
        console.log(e);
        //console.log('this.dataParent.storage.canvas', this.dataParent.storage.canvas.step);
        if (selectedObject === null) {
            return false;
        }
        if (!e.target.canvas.getActiveObject()) {
            //deleteBtns();
        }

        this.dataParent.class.Canvas.disableScroll(selectedObject.canvas);
        //console.log(selectedObject);

        // IF MOBILE SUB PANEL IS OPENDED
        if ($(".panel.active").length > 0)
            this.dataParent.class.Dom.closePanel($(".panel.active").attr("id"));

        if (selectedObject.get("name") === "fabricObj_text" || (this.dataParent.storage.productData.interface.panels.text.restrict.addEmoji[this.dataParent.storage.canvas.step] === true && this.dataParent.class.Canvas.isSitcker(selectedObject) === true && selectedObject.lockMovementY === true)
        ) {
            this.dataParent.class.Dom.openSwiper("text");
        } else if (this.dataParent.storage.productData.interface.panels.sticker.active === true && this.dataParent.class.Canvas.isSitcker(selectedObject) === true) {
            this.dataParent.class.Dom.openSwiper("sticker");
            console.log("OPEN SWIPER STICKER");
        } else if (this.dataParent.storage.productData.interface.panels.picture.active === true && selectedObject.name == "fabricObj_fond") {
            this.dataParent.class.Dom.openSwiper("picture");
        }
        this.dataParent.class.Canvas.setStepJsonCanvas();
    };

    onObjectMoved(e) {
        console.log('# onObjectMoved');
        //console.log(e);
        const dataParent = this.dataParent;
        dataParent.class.Canvas.disableScroll(e.target.canvas);

        if (e.target) {
            // COLLISION CTRL
            e.target.setCoords();


            e.target.opacity = 0.8;
            var obj = e.target;
            var canvas = obj.canvas;
            //console.log(canvas);
            console.log(obj.name);
            var name = obj.name;

            // GESTION OF SMILEYS

            if (typeof name !== "undefined" && name.indexOf("fabricObj_sticker") > -1) {
                if (dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.margin && obj.lockMovementY === true) {
                    var beltObject = dataParent.class.Canvas.getObject(canvas, "fabricObj_belt", 'ceinture');
                    // CALCUL ECART MARGE EXTERNE
                    var marginOut = (canvas.width - beltObject.width) / 2;
                    var objX = obj.left - marginOut;
                    console.log("marginOut : " + marginOut);
                    console.log("objX : " + objX);

                    var margin = beltObject.width * dataParent.storage.productData.interface.panels[dataParent.storage.tabActive].restrict.margin;
                    var objWidth = obj.width * obj.scaleX;

                    console.log("obj.left : " + obj.left);
                    console.log("beltObject width" + beltObject.width);
                    console.log("obj.width : " + obj.width);
                    console.log('resultat', beltObject.width - objWidth / 2 - margin);
                    console.log(beltObject);
                    if (objX > beltObject.width - objWidth / 2 - margin) {
                        console.log("depasse le right");
                        console.log("obj.left : " + obj.left);
                        console.log("obj.width : " + obj.width);
                        console.log("canvas.width : " + canvas.width);
                        console.log("margin : " + margin);
                        obj.left = marginOut + beltObject.width - objWidth / 2 - margin;
                    } else if (objX < objWidth / 2 + margin) {
                        console.log("depasse le left" + marginOut);
                        obj.left = marginOut + objWidth / 2 + margin;
                    }
                }
            }

        }
    };

    onObjectModified(e) {
        console.log("[onObjectModified]");
        if (e.target) {
            e.target.opacity = 1;
            //showBtns(e.target);
        }



        if (e.target.name && parseInt(e.target.canvas.id_canvas) == parseInt($("#load-template").attr("data-id_product"))) {
            //this.dataParent.class.Canvas.editOnClones(e.target);
        }

        if (this.dataParent.class.Canvas.isSitcker(e.target) === false && this.dataParent.storage.productData.interface.panels.text.restrict.unique === true) {
            console.log("[discardActiveObject]");
            //canvasActive.discardActiveObject();
        }
        this.dataParent.class.Canvas.setStepJsonCanvas();
    };

    onObjectSelected(e) {
        console.log("[onObjectSelected]");
        //console.log(e.target);

        //showBtns(e.target);
        $("#swiper-container-" + tabActive).find(".option.item-action").removeClass("offline");
        if (e.target.objectType == "picture") {
            var object = e.target;
            //console.log(object);
            //$('#zoom-panel').attr('data-origin-zoom', parseInt(object.scaleX * 1000));
            //$('#picture-zoom').attr('min', parseInt((object.scaleXOriginal * 1000) / 2));
            //$('#picture-zoom').attr('max', parseInt((object.scaleXOriginal * 1000) * 2));
            //$('#picture-zoom').val(parseInt(object.scaleX * 1000));
            console.log("VALUE actuelle :" + parseInt(object.scaleX * 1000));
        }
    };

    onObjectRemoved(e) {
        console.log("# onObjectRemoved : " + e.target.name);
        //console.log(e);


        var Object = e.target;
        if (Object.name === "fabricObj_fond") {
            //$("#imageLoader").val("");
        }
        if (e.target) {
            //this.dataParent.class.Canvas.removeOnClones(e.target);
        }
        this.dataParent.class.Dom.commandBtnUpdate(e.target.canvas);
        this.dataParent.class.Canvas.setStepJsonCanvas();
    };


    onObjectAdded(e) {
        console.log('# onObjectAdded : ', e.target.name);
        if (e.target.name && parseInt(e.target.canvas.id_canvas) == parseInt($("#load-template").attr("data-id_product"))) {
            console.log("[onObjectAdded " + e.target.name + " ON CANVAS " + e.target.canvas.id_canvas + " FOR COPY/PASTE] :");
            //console.log(e.target);
            e.target.canvas.setActiveObject(e.target);
            //this.dataParent.class.Canvas.addOnClones(e.target);
        }
        this.dataParent.class.Dom.commandBtnUpdate(e.target.canvas);
        this.dataParent.class.Canvas.disableScroll(e.target.canvas);
        this.dataParent.class.Canvas.setStepJsonCanvas();
    };

    onObjectRotated(e) {
        console.log('onObjectRotated');
        if (e.target && e.target.canvas) {
            var rotatedObject = e.target;
            var canvasName = e.target.canvas;
        } else {
            var rotatedObject = e;
            var canvasName = this.dataParent.storage.canvas;
        }
        this.dataParent.class.Dom.initInputSlide(rotatedObject);

    };

    onObjectScaled(e) {
        console.log('onObjectScaled');

        const dataParent = this.dataParent;
        if (e.target && e.target.canvas) {
            var scaledObject = e.target;
            var canvasName = e.target.canvas;
        } else {
            var scaledObject = e;
            var canvasName = dataParent.storage.canvas;
        }



        let percentageObjectData = dataParent.class.Canvas.percentageObject(scaledObject, canvasName);
        if (scaledObject.flipX == true || scaledObject.flipY == true) {
            scaledObject.flipX = false;
            scaledObject.flipY = false;
        }
        console.log("# object scaled", $("#alert-icon-size:hidden").length, scaledObject.scaleX, dataParent.class.Canvas.ratioMax(percentageObjectData.RatioReductionImgVersCanvas, 1.3), scaledObject.objectType);

        if ($("#alert-icon-size:hidden").length == "1" && scaledObject.scaleX > dataParent.class.Canvas.ratioMax(percentageObjectData.RatioReductionImgVersCanvas, 1.3) && scaledObject.objectType == "picture") {
            console.log('ok for message', dataParent.storage.notice);
            if (dataParent.storage.notice.ratio === false) {
                dataParent.storage.notice.ratio = iziToast.question({
                    timeout: false,
                    transitionIn: false,
                    transitionOut: false,
                    transitionInOverlay: false,
                    transitionOutOverlay: false,
                    theme: 'dark',
                    color: '#fff',
                    class: 'custom_izitoast',
                    backgroundColor: '#222',
                    close: false,
                    maxWidth: '500px',
                    overlay: true,
                    displayMode: 'once',
                    id: 'question',
                    zindex: 999,
                    message: `<b>Attention, vous avez augmenté la taille de votre image originale de 130%. Cela risque de dégrader la qualité de votre personnalisation.</b>`,
                    position: 'center',
                    buttons: [
                        [
                            "<button>J'ai bien compris</button>", function (instance, toast) {
                                instance.hide({ transitionOut: 'fadeOut', }, toast, 'same');
                            },
                            true,
                        ],
                    ],
                    onClosing: function (instance, toast, closedBy) {
                        console.info('Closing | closedBy: ' + closedBy);
                    },
                    onClosed: function (instance, toast, closedBy) {
                        console.info('Closed | closedBy: ' + closedBy);

                    }
                });
            }

        } else if (($("#alert-icon-size:visible").length == "1" || $("#personnalisation-info").length == "1") &&
            scaledObject.scaleX < ratioMax(percentageObjectData.RatioReductionImgVersCanvas, 1.2)
        ) {
            //$('.ui-pnotify').remove();
            $("#alert-icon-size").hide();
        }

        //var zoomInput = ((scaledObject.scaleX * 100) / scaledObject.scaleXOriginal) - 100;

        this.dataParent.class.Dom.initInputSlide(scaledObject);

    };
    onObjectMouseovered(e) {
        console.log("# onObjectMouseovered");
    };

    onAfterRender(e) {


        if (e.target && e.target.canvas) {
            console.log('[onAfterRender]');
            e.target.canvas.getObjects().forEach(function (e) {
                //console.log("liste :"+o.name+" -> objet recherché :"+ObjectName);
                console.log("Objet onAfterRender");
                console.log(e);
            });
            this.dataParent.class.Canvas.moveToObject(this.dataParent.storage.canvas, "fabricObj_fond", 'picture');
            this.dataParent.class.Canvas.moveToObject(this.dataParent.storage.canvas, "fabricObj_belt", 'ceinture');
            //moveToObject(canvas, "fabricObj_boxer", 30);
            this.dataParent.class.Canvas.moveToTopObject(this.dataParent.storage.canvas, "fabricObj_text", 'text');


        }
        //console.log("onAfterRender fin :", this.dataParent.storage);

    };

    onSelectionUpdated(e) {
        console.log("############## onSelectionUpdated trigger ");
        if (e.target && e.target.canvas) {
            var canvas = e.target.canvas;
            var selectedObject = e.target;
            console.log(selectedObject);
            //if()
            //canvas.bringToFront(selectedObject);
            this.dataParent.class.Dom.initInputSlide(selectedObject);
            //deleteBtns();

            this.dataParent.class.Canvas.onSelectionCreated(e);
        }
    };

    onSelectionCreated(e) {
        var selectedObject = e.target;
        console.log("# onSelectionCreated", selectedObject);

        //addDeleteBtn(selectedObject);
        if (selectedObject !== undefined) {
            //console.log("# what !!", selectedObject);
            if ($(".panel.active").length == 0 || $(".text.panel.active").length == 1 || $(".photo.panel.active").length == 1 || $(".example.panel.active").length == 1) {
                if (selectedObject.name == "fabricObj_fond" && typeof this.dataParent.storage.swiper["picture"] !== "undefined") {
                    //openSwiper('picture');
                } else if (this.dataParent.class.Canvas.isSitcker(selectedObject) === true && typeof this.dataParent.storage.swiper["text"] !== "undefined") {
                    //openSwiper();
                    console.log("# ok sticker");
                } else if (selectedObject.name == "fabricObj_text" && typeof this.dataParent.storage.swiper["text"] !== "undefined") {
                    //openSwiper('text');
                }
            }

            if ($("#smiley-panel").length > 0 && this.dataParent.class.Canvas.isSitcker(selectedObject) === false && $("#smiley-panel").hasClass("active") === true) {
                //closePanel('smiley-panel', 'cancel');
            }
        }
    };
}